export default __webpack_public_path__ + "static/media/utilities.00cd5b2a.png";